<template>
  <iframe width="100%" height="100%" :src="uri"></iframe>
</template>

<script>
// test
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "trainingMagytrack",
  data() {
    return {
      uri: "https://apicloud.magycorp.com:48028/docs/MAGYTRACK/MANUAL%20PLATAFORMA%20MAGYTRACK.pdf"
    };
  }
};
</script>

<style></style>
